import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { debounceTime, finalize, switchMap } from 'rxjs/operators';
import { SalespersonsServiceProxy, CreateOrEditSalespersonDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    selector: 'createOrEditSalespersonModal',
    templateUrl: './create-or-edit-salesperson-modal.component.html',
    standalone: false,
})
export class CreateOrEditSalespersonModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    salesperson: CreateOrEditSalespersonDto = new CreateOrEditSalespersonDto();

    constructor(
        injector: Injector,
        private _salespersonsServiceProxy: SalespersonsServiceProxy,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {}

    show(salespersonId?: number): void {
        if (!salespersonId) {
            this.salesperson = new CreateOrEditSalespersonDto();
            this.salesperson.id = salespersonId;

            this.active = true;
            this.modal.show();
        } else {
            this._salespersonsServiceProxy.getSalespersonForEdit(salespersonId).subscribe((result) => {
                this.salesperson = result.salesperson;

                this.active = true;
                this.modal.show();
            });
        }
    }

    save(): void {
        this.saving = true;

        this._salespersonsServiceProxy
            .createOrEdit(this.salesperson)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
